<template>
  <nuttrema-layout-form-standard :edit="edit" :saveError="PersonDetails.saveError">
    <template slot="center">
      <el-form
        :rules="rules"
        :ref="formRef"
        :model="formData"
        :label-position="labelPosition"
        label-width="20em">

        <section>
          <el-form-item :label="$t('label.status')">
            <el-col class="el-col--min-25em" :span="8">
              <el-select v-model="formData.status" class="w-100" :disabled="!edit">
                <el-option-group
                 v-for="group in options"
                :key="group.label"
                :label="$t(group.label)">
                  <el-option
                     v-for="item in group.options"
                    :key="item.key"
                    :label="$t(item.label)"
                    :disabled="item.disabled"
                    :value="item.key">
                  </el-option>
                </el-option-group>
              </el-select>
            </el-col>
            <el-col :span="24">
              <p class="el-form-item__help">{{ $t(`label.status_${related}_${formData.status}_help`) }}</p>
            </el-col>
          </el-form-item>
        </section>
      </el-form>
    </template>

    <template slot="footer">
      <nav class="footer-row">
        <el-button
           type="primary"
           size="small"
          :loading="isSaving"
          :disabled="!isDataChanged"
          @click="submitForm">
          {{ $t('label.save') }}
        </el-button>

        <el-button
           type="text"
           size="small"
          @click="cancelChanges">
          <span v-if="showDoneButton">{{ $t('label.done') }}</span>
          <span v-else>{{ $t('label.cancel') }}</span>
        </el-button>
      </nav>
    </template>

  </nuttrema-layout-form-standard>
</template>

<script>
import { get } from 'lodash';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

export default {
  name: 'form-person-status',
  mixins: [
    FormStandardBehavior,
  ],
  props: {
    id: {
      required: false,
      default: null,
    },
    related: {
      required: false,
      default: null,
    },
    labelPosition: {
      type: String,
      required: false,
      default: 'right',
    },
    PersonDetails: {
      type: Object,
      required: false,
    },
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
    options: {
      type: Array,
      required: false,
      default: () => [
        {
          label: 'label.regular',
          options: [
            {
              key: 'draft',
              label: 'label.draft',
              disabled: true,
            },
            {
              key: 'active',
              label: 'label.active',
              disabled: false,
            },
            {
              key: 'inactive',
              label: 'label.inactive',
              disabled: false,
            },
          ],
        },
      ],
    },
  },
  components: {
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      formData: {
        status: null,
      },
      rules: {
        status: [
          {
            required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.status', true),
          },
        ],
      },
    };
  },
  methods: {
    setFormData() {
      this.formData.status = get(this.PersonDetails, 'data.status', null);
    },
    getFormData() {
      return this.formData;
    },
  },
  created() {
    this.stateData = this.PersonDetails;
    this.formRef = 'form-person-status';
    this.setFormData();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/shared/status/form-person-status.vue